export default defineNuxtPlugin((nuxtApp) => {
  const router = nuxtApp.$router
  const scroll = router.options.scrollBehavior
  // A public Forms fragment is a bearer secret, never an anchor selector.
  router.options.scrollBehavior = (to, from, savedPosition) =>
    to.path === '/q/respond' ? false : scroll?.(to, from, savedPosition)
})
